import React, { useEffect, useRef, useState, useMemo } from 'react';
import appState from '../../state/AppStateContainer';
import { ServiceUser } from '../../services/service-user';
import { ServiceChat } from '../../services/service-chat';

import Tabs from '../../components/shared/Tabs';
import NotificationCounter from '../../components/shared/NotificationCounter/NotificationCounter';
import BtButton from '../bt-button/bt-button';
import SearchBarWithActions from '../../components/shared/SearchBarWithActions/SearchBarWithActions';
import Selector from '../../components/shared/Selector/Selector';
import MaterialTable from 'material-table';
import './page-project-intern-list.css';
import { CustomAvatar, Loading } from '../../components/shared';
import OverflowTip from '../../components/shared/OverflowTip/OverflowTip';
import OptionsMenu from '../../components/shared/OptionsMenu/OptionsMenu';
import { serviceProfile } from '../../services/service-profile';
import AppLayout from '../../components/layout/app-layout/app-layout';
import { ServiceProjects } from '../../services/service-projects';
import AddMember from '../page-internal-chat/add-member';
import appEnum from '../../util/appEnum';
import Modal from '../../components/shared/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { isAfter } from 'date-fns';
import { NotificationManager } from 'react-notifications';

const PageProjectInternList = ({ isLoading, history }) => {
  const tableRef = useRef();
  const appAddMemberRef = useRef();
  const [allColleagues, setAllColleagues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [screenLoader, setScreenLoader] = useState(false);
  const [showModalAddMember, setShowModalAddMember] = useState(false);
  const [currentMemberToEdit, setCurrentMemberToEdit] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [submitBtnLoader, setSubmitBtnLoader] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [roleFilter, setRoleFilter] = useState([]);
  const [t] = useTranslation('users');
  const [showRemoveUserConfirmationModal, setShowRemoveUserConfirmationModal] = useState(false);
  const [showRenewInvitationConfirmationModal, setShowRenewInvitationConfirmationModal] = useState(false);
  const [currentMemberToRemoveOrRenew, setCurrentMemberToRemoveOrRenew] = useState(null);
  const [confirmationModalTitle, setConfirmationModalTitle] = useState('');

  const roleLabels = {
    [appEnum.Role.Client]: t('role.client', 'Beställare'),
    [appEnum.Role.Kalkyl]: t('role.visitor', 'Besökare'),
    [appEnum.Role.Inköp]: t('role.participant', 'Deltagare'),
    [appEnum.Role.Admin]: t('role.admin', 'Administratör'),
    [appEnum.Role.SuperAdmin]: t('role.superAdmin', 'Superadmin'),
  }

  const roleFilterOptions = [
    { value: appEnum.Role.Admin, label: t('role.admin', 'Administratör') },
    { value: 'Inköp', label: t('role.participant', 'Deltagare') },
    { value: 'Kalkyl', label: t('role.visitor', 'Besökare') },
    { value: 'Client', label: t('role.client', 'Beställare') },
    { value: 'unanswered', label: t('role.unanswered', 'Obesvarad inbjudan') },
  ];

  useEffect(() => {
    const startProcessing = async () => {
      setLoading(true);
      try {
        let _colleagues = await serviceProfile.getColleagues();
        const chatNotifications = await ServiceChat.getNotifications();
        _colleagues.map(x => {
          var result = chatNotifications.filter(n => n.fromUserId == x._id);
          if (result.length > 0) {
            x.notificationCount = result[0].count;
          }
          return x;
        });
        tableRef.current.dataManager.changePageSize(_colleagues.length);
        setAllColleagues(_colleagues);
      } catch (e) {
        console.error('error', e);
      }

      setLoading(false);
      appState.setState({ loader: false });
    };

    startProcessing().catch(console.error);
  }, []);

  useEffect(() => {
    const socket = ServiceChat.createSocket(appState.getUserToken());
    socket.on('chatmessage', x => {
      const matchSlug = x.orgSlugs && x.orgSlugs.includes(appState.getCurrentOrgSlug());
      if (!matchSlug) return;
      subscriber(x);
    });

    return () => {
      socket.off('chatmessage');
    };
  }, []);

  const colleagues = useMemo(() => {
    let res = allColleagues
      .filter(user => {
        const search = searchValue.toLowerCase();
        const matchesSearch = !searchValue ||
          (user.name.toLowerCase().startsWith(search) ||
           (user.email && user.email.toLowerCase().includes(search)));

        const matchesRole = roleFilter.length === 0 ||
          roleFilter.some(filter => {
            if (filter.value === 'unanswered') {
              return user.invitationCode && !user.isActive;
            }
            return user.role === filter.value;
          });

        return matchesSearch && matchesRole;
      })
      .sort((a, b) => a.name.localeCompare(b.name));
    tableRef?.current?.dataManager?.changePageSize(res.length);
    return res;
  }, [allColleagues, searchValue, roleFilter]);

  const subscriber = async messageObject => {
    await ServiceChat.updateNotifications(messageObject.fromUserId);
    updateNotification(messageObject.fromUserId);
  };

  const updateNotification = async id => {
    const pathName = window.location.pathname;
    const urlLength = pathName.split('/').length;
    let notifyColleagues = [...allColleagues];

    if (id !== appState.getUserId()) {
      let i = -1;
      const checkIntern = await notifyColleagues.find((c, _i) => {
        i = _i;
        return c._id == id;
      });
      if (i > -1 && !checkUrl(pathName, checkIntern.slug)) {
        // don't notify for opened chat
        if (!notifyColleagues[i].notificationCount) {
          notifyColleagues[i].notificationCount = 1;
        } else {
          notifyColleagues[i].notificationCount++;
        }

        setAllColleagues(notifyColleagues);
        if (urlLength > 2) await ServiceChat.updateNotifications(id);
      }
    }
  };

  const checkUrl = (str, strToSearch) => {
    const url = str.split('/');
    return url.find(e => e == strToSearch);
  };

  const onInternClick = async internId => {
    const _allColleagues = [...allColleagues];
    let selectedInternIdx = _allColleagues.findIndex(i => i._id === internId);
    _allColleagues[selectedInternIdx].notificationCount = 0;
    await ServiceChat.clearNotifications(internId);
    setAllColleagues(_allColleagues);
  };

  const removeInternLocally = async internId => {
    setShowRemoveUserConfirmationModal(false);
    try {
      await ServiceUser.removeUser(internId);
      NotificationManager.success(
        t('notification.removeUser.description.success', 'Användaren har tagits bort')
      );
      setAllColleagues(allColleagues.filter(i => i._id !== internId));
    } catch (e) {
      NotificationManager.error(
        e?.response?.data?.error,
        t('notification.removeUser.description.error', 'Användaren kunde inte tas bort')
      );
    }
  };

  const onRenewInvitation = async email => {
    setShowRenewInvitationConfirmationModal(false);
    const response = await serviceProfile.renewUserInvitation({ email });
    if (response.status === 200) {
      NotificationManager.success(
        t('notification.renewInvitation.description.success', 'Ny inbjudan skickad')
      );
      const _allColleagues = [...allColleagues];
      let selectedInternIdx = _allColleagues.findIndex(i => i.email === email);
      _allColleagues[selectedInternIdx] = response.user;
      setAllColleagues(_allColleagues);
    } else {
      NotificationManager.error(
        t('notification.renewInvitation.description.error', 'Det gick inte att skicka den förnyade inbjudan')
      );
    }
  }

  const onRemoveOrRenewConfirmation = () => {
    if (showRemoveUserConfirmationModal) {
      removeInternLocally(currentMemberToRemoveOrRenew?._id);
    } else if (showRenewInvitationConfirmationModal) {
      onRenewInvitation(currentMemberToRemoveOrRenew?.email);
    }
  };


  const getColumns = () => {
    return [
      {
        title: t('table.header.name', 'Namn'),
        cellStyle: { fontSize: null },
        field: 'name',
        render: rowData => {
          const unansweredInvitation = !rowData?.isActive && rowData.invitationCode;
          const expiredInvitation = unansweredInvitation && rowData.invitationCodeExpirationDate ? isAfter(new Date(), new Date(rowData.invitationCodeExpirationDate)) : false;
          const name = expiredInvitation ? t('invitation.expiredInvitation', 'Obesvarad inbjudan - har löpt ut') : unansweredInvitation ? t('invitation.unansweredInvitation', 'Obesvarad inbjudan') : rowData?.name;
          return(
          <div className="name">
            <CustomAvatar alt={unansweredInvitation ? '?' : rowData?.name} src={rowData?.avatarUrl} />
            <span>{name}</span>
            <NotificationCounter counter={parseInt(rowData?.notificationCount)} />
          </div>
        )},
      },
      {
        title: t('table.header.eMail', 'E-post'),
        cellStyle: { fontSize: null },
        field: 'email',
        render: rowData => <div className="email">{rowData?.email}</div>,
      },
      {
        title: t('table.header.role', 'Roll'),
        cellStyle: { fontSize: null },
        field: 'role',
        render: rowData => <div className="role">{roleLabels[rowData?.role]}</div>,
      },
      {
        title: t('table.header.project', 'Projekt'),
        cellStyle: { fontSize: null, minWidth: '25vw' },
        render: getProjects,
      },
      {
        title: '',
        align: 'center',
        render: rowData => {
          const hasEditAccess = rowData?._id && !appState.superAdminOrgAndUser() && appState.isAdminRole();
          const hasRemoveAccess = appState.isAdminRole() && rowData._id != appState.getUserId();
          const canRenewInvitation = appState.isAdminRole() && !rowData?.isActive && rowData.invitationCodeExpirationDate && isAfter(new Date(), new Date(rowData.invitationCodeExpirationDate));
          const options = [];
          if (hasEditAccess) {
            options.push({
              label: t('table.row.tools.edit', 'Redigera'),
              action: () => onEditMember(rowData),
            });
          }
          if (hasRemoveAccess) {
            options.push({
              label: t('table.row.tools.delete.label', 'Ta bort'),
              action: () => {
                setCurrentMemberToRemoveOrRenew(rowData);
                setConfirmationModalTitle(t('modal.confirmRemove.title', 'Bekräfta borttagning av användare'));
                setShowRemoveUserConfirmationModal(true);
              },
            });
          }
          if (canRenewInvitation) {
            options.push({
              label: t('table.row.tools.renewInvitation.label', 'Förnya inbjudan'),
              action: () => {
                setCurrentMemberToRemoveOrRenew(rowData);
                setConfirmationModalTitle(t('modal.confirmRenewInvitation.title', 'Bekräfta förnyelse av inbjudan'));
                setShowRenewInvitationConfirmationModal(true);
              },
            });
          }
          return (
            <div
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              {!isLoading && (
                <OptionsMenu
                  style={{ width: '100%', height: '100%', display: 'grid', placeItems: 'center' }}
                  options={options}
                />
              )}
            </div>
          );
        },
        cellStyle: {
          width: '30px',
        },
      },
    ];
  };

  const getProjects = rowData => {
    if (rowData?.projects?.length) {
      const projectNames = Array.from(
        rowData?.projects
          ?.map(p => ` ${p?.projectId?.name}`)
          .reduce((set, name) => set.add(name), new Set())
        ).toSorted((a,b) => a.localeCompare(b, undefined, {numeric: true}));

      return <OverflowTip content={projectNames} />;
    }
    return '';
  };

  const handleSearchUsers = searchedValue => {
    setSearchValue(searchedValue);
  };

  const getProjectList = async () => {
    const _projectList = await ServiceProjects.getProjectList();
    setProjectList(_projectList);
  };

  const onAddMember = async () => {
    if (!showModalAddMember) {
      setShowModalAddMember(true);
      setCurrentMemberToEdit(null);
      await getProjectList();
    }
  };

  const onEditMember = async currentMember => {
    setScreenLoader(true);
    setShowModalAddMember(true);
    setCurrentMemberToEdit(currentMember);
    await getProjectList();
    setScreenLoader(false);
  };

  const updateMemberLocally = (updatedMember) => {
    let _allColleagues = [...allColleagues]
    const updatedIdx = _allColleagues.findIndex(c => c._id === updatedMember?._id);

    _allColleagues[updatedIdx] = updatedMember;

    setColleaguesLocally(_allColleagues);
    setCurrentMemberToEdit(null);
  }

  const addMemberLocally = async (newMember) => {
    await getProjectList();
    let _allColleagues = [...allColleagues]
    const updatedIdx = _allColleagues.findIndex(c => c._id === newMember?._id);

    if(updatedIdx > -1) _allColleagues[updatedIdx] = newMember;
    else _allColleagues = [newMember, ...colleagues];

    setColleaguesLocally(_allColleagues);
    setCurrentMemberToEdit(null);
  }

  const setColleaguesLocally = (_allColleagues) => {
    setAllColleagues(_allColleagues);
  }

  const toggleBtnLoader = (value) => setSubmitBtnLoader(value);

  return (
    <>
      <div>{screenLoader && <Loading />}</div>
      <AppLayout title={t('pageTitle', 'Användare')}>
        <div className="internChatMenuContainer">
          <div className="tab-container">
            <Tabs tabs={[t('tabs.all', 'Alla')]} selected={0} />
            {appState.isAdminRole() && (
              <div className="tab-actions">
                <BtButton onClick={onAddMember}>{t('button.addMember', 'Lägg till användare')}</BtButton>
              </div>
            )}
          </div>

          <SearchBarWithActions
            value={searchValue}
            onChange={handleSearchUsers}
          >
            <div className="selector-row">
              <Selector
                isMulti
                isClearable
                isOverflow
                placeholder={t('table.header.role', 'Roll')}
                options={roleFilterOptions}
                value={roleFilter}
                onChange={(selected) => setRoleFilter(selected || [])}
              />
            </div>
          </SearchBarWithActions>
          <div className="internTableContainer">
            <MaterialTable
              localization={{ body: { emptyDataSourceMessage: t('table.emptyMessage', 'Kunde inte hitta något resultat') } }}
              options={{
                sorting: false,
                draggable: false,
                search: false,
                toolbar: false,
                detailPanelColumnStyle: { display: 'none' },
                rowStyle: () => ({ color: 'var(--gray-800)' }),
              }}
              tableRef={tableRef}
              style={{ margin: '25px 0' }}
              columns={getColumns()}
              data={colleagues}
              components={{ Pagination: () => null }}
              isLoading={loading}
              onRowClick={(e, rowData) => {
                if (!rowData?.isActive && rowData.invitationCode) return;
                const orgSlug = appState.getCurrentOrgSlug();
                history.push(`/${orgSlug}/chat/${rowData.slug}`);
                onInternClick(rowData?._id);
              }}
            ></MaterialTable>
          </div>
        </div>
        <Modal
          title={currentMemberToEdit ? t('modal.edit.title', 'Redigera användare') : t('modal.add.title', 'Lägg till användare')}
          center
          name="modal-add-member"
          show={showModalAddMember}
          buttonInfo={{
            label: currentMemberToEdit ? t('modal.edit.saveButton', 'Spara') : t('modal.add.saveButton', 'Lägg till'),
            action: () => appAddMemberRef?.current?.handleSubmit(),
            loaderShow: submitBtnLoader,
            disabled: submitBtnLoader
          }}
          setShow={() => {
            if(submitBtnLoader) return;
            setShowModalAddMember(false)
            setTimeout(() => {
              if (appAddMemberRef?.current?.reset) appAddMemberRef.current.reset();
              setCurrentMemberToEdit(null);
            }, 300);
          }}
        >
          <AddMember
            projects={projectList}
            currentMember={currentMemberToEdit}
            ref={appAddMemberRef}
            updateMemberLocally={updateMemberLocally}
            addMemberLocally={addMemberLocally}
            onClose={() => {
              setShowModalAddMember(false)
              setTimeout(() => {
                if (appAddMemberRef?.current?.reset) appAddMemberRef.current.reset();
                setCurrentMemberToEdit(null);
              }, 300);
            }}
            toggleBtnLoader={toggleBtnLoader}
          />
        </Modal>
        {(showRemoveUserConfirmationModal || showRenewInvitationConfirmationModal) && <Modal
          title={confirmationModalTitle}
          center
          name="confirmation-modal"
          show={showRemoveUserConfirmationModal || showRenewInvitationConfirmationModal}
          setShow={(value) => {
            setShowRemoveUserConfirmationModal(value);
            setShowRenewInvitationConfirmationModal(value);
            if(!value) {
              setCurrentMemberToRemoveOrRenew(null);
            }
          }}
          buttonInfo={{
            label: t('modal.button.confirm', 'Bekräfta'),
            action: () => onRemoveOrRenewConfirmation(),
          }}
          onCancelButtonClick={() => {
            setShowRemoveUserConfirmationModal(false);
            setShowRenewInvitationConfirmationModal(false);
            setCurrentMemberToRemoveOrRenew(null);
          }}
        >
          {showRemoveUserConfirmationModal && <p>{t('modal.confirmRemove.description', 'Är du säker på att du vill ta bort användaren med e-postadressen {{email}}?', { email: currentMemberToRemoveOrRenew?.email })}</p>}
        </Modal>}
      </AppLayout>
    </>
  );
};

export default PageProjectInternList;
